module.exports = __webpack_public_path__ + "img/logo-viberto.26119da5.png";